import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/footer/main.footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/header/MainHeader.tsx");
